'use strict';
/**
 * Sanitizer
 *
 * 文字列を無害化するための Module です。
 * 渡された文字列を無害化した文字列に変換し出力します。
 *
 * - sanitize
 *
 * @example
 * sanitize(dirtyString);
 */

const DOMPurify = require('dompurify');

const sanitize = function(dirty) {
    // XSS の防止のために HTML コードを無害化する
    return DOMPurify.sanitize(dirty);
};

module.exports = {
    sanitize: sanitize
};



// WEBPACK FOOTER //
// ./common/util/sanitizer.js